/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_ContinueInputs */

const cs_templates_use_picker_continue = /** @type {(inputs: Templates_Use_Picker_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokračovat`)
};

const en_templates_use_picker_continue = /** @type {(inputs: Templates_Use_Picker_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Templates_Use_Picker_ContinueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_continue = /** @type {((inputs?: Templates_Use_Picker_ContinueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_ContinueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_continue(inputs)
	return cs_templates_use_picker_continue(inputs)
});